import React, { Fragment } from 'react';
import styled from 'styled-components';
import { Typo } from 'tmt-ui-kit';
import xss from 'xss';

const Container = styled.div`
  margin-bottom: 24px;
`;

const Header = styled(Typo.HeaderTwo)`
  margin: 16px 0px;
  text-transform: capitalize;
`;

const Content = styled(Typo.Paragraph)`
  padding-bottom: 16px !important;
  font-size: 15px !important;
  white-space: pre-wrap;
  &:last-child {
    padding-bottom: 0px !important;
  }
`;
const FAQ = props => {
  const { trip } = props;
  return (
    <Container>
      {trip.faqs.map(faq => (
        <Fragment key={faq.question}>
          <Header>{faq.question}</Header>
          <Content>
            <span dangerouslySetInnerHTML={{ __html: xss(faq.answer)}} />
          </Content>
        </Fragment>
      ))}
    </Container>
  );
};

export default FAQ;
